define("shared/models/flatpickr-config", ["exports", "@ember/debug"], function (_exports, _debug) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  class FlatpickrConfig {
    constructor(_ref) {
      let {
        onValueUpdate,
        onChange,
        onClose,
        onOpen,
        altFormat,
        altInput = false,
        allowInvalidPreload = false,
        appendTo,
        clickOpens = true,
        dateFormat,
        defaultDate,
        disableMobile = false,
        enableTime = false,
        formatDate,
        locale = {
          rangeSeparator: ' - '
        },
        minuteIncrement = 5,
        maxDate,
        minDate,
        mode = 'single',
        noCalendar = false,
        position = 'auto',
        showMonths = 1,
        time_24hr = false,
        wrap = false
      } = _ref;

      _defineProperty(this, "onValueUpdate", void 0);

      _defineProperty(this, "onChange", void 0);

      _defineProperty(this, "onClose", void 0);

      _defineProperty(this, "onOpen", void 0);

      _defineProperty(this, "altFormat", void 0);

      _defineProperty(this, "altInput", void 0);

      _defineProperty(this, "allowInvalidPreload", void 0);

      _defineProperty(this, "appendTo", void 0);

      _defineProperty(this, "clickOpens", void 0);

      _defineProperty(this, "dateFormat", void 0);

      _defineProperty(this, "defaultDate", void 0);

      _defineProperty(this, "disableMobile", void 0);

      _defineProperty(this, "enableTime", void 0);

      _defineProperty(this, "formatDate", void 0);

      _defineProperty(this, "locale", void 0);

      _defineProperty(this, "minuteIncrement", void 0);

      _defineProperty(this, "maxDate", void 0);

      _defineProperty(this, "minDate", void 0);

      _defineProperty(this, "mode", void 0);

      _defineProperty(this, "noCalendar", void 0);

      _defineProperty(this, "position", void 0);

      _defineProperty(this, "showMonths", void 0);

      _defineProperty(this, "time_24hr", void 0);

      _defineProperty(this, "wrap", void 0);

      (false && !(typeof onValueUpdate === 'function' || typeof onChange === 'function') && (0, _debug.assert)('Must provide one of onValueUpdate or onChange to FlatpickrConfig', typeof onValueUpdate === 'function' || typeof onChange === 'function'));
      this.onValueUpdate = onValueUpdate;
      this.onChange = onChange;
      this.onClose = onClose;
      this.onOpen = onOpen;
      this.altFormat = altFormat ?? dateFormat;
      this.altInput = altInput;
      this.appendTo = appendTo;
      this.allowInvalidPreload = allowInvalidPreload;
      this.clickOpens = clickOpens;
      this.dateFormat = dateFormat;
      this.locale = locale;
      this.defaultDate = defaultDate;
      this.disableMobile = disableMobile;
      this.enableTime = enableTime;
      this.formatDate = formatDate;
      this.minuteIncrement = minuteIncrement;
      this.maxDate = maxDate;
      this.minDate = minDate;
      this.mode = mode;
      this.noCalendar = noCalendar;
      this.position = position;
      this.showMonths = showMonths;
      this.time_24hr = time_24hr;
      this.wrap = wrap;
    }

  }

  _exports.default = FlatpickrConfig;
});